/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";

import { MdMenu } from "react-icons/md/";
import { FaExclamation } from "react-icons/fa/";
import { NavLink } from "react-router-dom";

import * as select from "../reducers";
import * as actionsSettings from "../actions/settings";
import * as actionsModals from "../actions/modals";
import * as actionsHelp from "../actions/help";

import "../styles/components/_navigation.scss";
import "../styles/components/modals/_tooltip-modal.scss";
import "../styles/components/modals/_cc-expiry.scss";
import { Auth } from "../api";

import logo from "../assets/images/afes-primary-logo-with-tagline-white-rgb.svg";
import { getBaseUrl } from "../api/axios";

class Navigation extends Component {
  settingsPersonalDefaults() {
    const { personal, creditCardExpired, creditCardExpiring, isImpersonating } =
      this.props;
    return {
      showAlert: creditCardExpiring,
      isExpired: creditCardExpired,
      isImpersonating,
      ...personal,
    };
  }

  toggleNavlinkAction() {
    // if (this.props.navlinks === true && typeof arguments[0].target.href !== "undefined") {
    //   window.location.href = arguments[0].target.href;
    // }
  }

  render() {
    const isLoggedIn = this.props.isAuthed;
    const {
      navlinks,
      setModalHelpOpen,
      setModalLoginFormOpen,
      showAdmin,
      personal,
    } = this.props;

    const handleLogOut = () =>
      Auth.doLogout().then(() => window.location.assign("/"));

    const handleStopImpersonating = () => {
      window.location.assign(`${getBaseUrl()}impersonate/stop?`);
    };

    return (
      <div className="nav">
        <div className="nav__wrap">
          <hr />
          <ConnectedUserDropdown
            navlinks={navlinks}
            userDetails={this.settingsPersonalDefaults()}
          />

          <a className="nav__logo" href="/">
            <img src={logo} alt="logo" width="120" />
          </a>

          <div className="right nav__actions">
            <div className="nav__desktop">
              {isLoggedIn && (
                <React.Fragment>
                  {this.props.reports && (
                    <NavLink
                      className={({ isActive }) =>
                        `fancy-nav ${isActive ? "active" : ""}`
                      }
                      to="/reports"
                      onClick={this.toggleNavlinkAction}
                    >
                      Staff Reports
                    </NavLink>
                  )}
                  <NavLink
                    className={({ isActive }) =>
                      `fancy-nav ${isActive ? "active" : ""}`
                    }
                    to="/programs"
                    onClick={this.toggleNavlinkAction}
                  >
                    Current Support
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      `fancy-nav ${isActive ? "active" : ""}`
                    }
                    to="/payment"
                    onClick={this.toggleNavlinkAction}
                  >
                    New Support
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      `fancy-nav ${isActive ? "active" : ""}`
                    }
                    to="/settings"
                    onClick={this.toggleNavlinkAction}
                  >
                    {personal?.organisation_name ? "Organisation" : "Personal"}{" "}
                    Details
                  </NavLink>

                  <ConnectedAlertDropdown
                    navlinks={navlinks}
                    userDetails={this.settingsPersonalDefaults()}
                  />

                  <NavLink
                    className={({ isActive }) =>
                      `fancy-nav ${isActive ? "active" : ""}`
                    }
                    to="/history"
                    onClick={this.toggleNavlinkAction}
                  >
                    Support History
                  </NavLink>
                </React.Fragment>
              )}

              <NavLink
                data-remodal-target="help-modal"
                to="/faq"
                className={({ isActive }) =>
                  `fancy-nav secondary ${isActive ? "active" : ""}`
                }
                onClick={(e) => {
                  e.preventDefault();
                  setModalHelpOpen();
                }}
              >
                Help
              </NavLink>

              {showAdmin && (
                <a className="fancy-nav secondary secondary" href="/admin">
                  Admin
                </a>
              )}

              {isLoggedIn ? (
                <>
                  {this.props.isImpersonating && (
                    <a
                      className="fancy-nav secondary login_button_header secondary"
                      href="#"
                      onClick={handleStopImpersonating}
                    >
                      Stop impersonating
                    </a>
                  )}
                  <button
                    className="fancy-nav secondary login_button_header secondary"
                    href="#"
                    onClick={handleLogOut}
                  >
                    Logout
                  </button>
                </>
              ) : (
                <React.Fragment>
                  <a
                    href={`${process.env.REACT_APP_API_URL}/oauth/azure`}
                    className="fancy-nav secondary"
                  >
                    Staff
                  </a>

                  <NavLink
                    data-remodal-target="login-modal"
                    to="/programs"
                    className={({ isActive }) =>
                      `fancy-nav secondary login_button_header js__login ${
                        isActive ? "active" : ""
                      }`
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setModalLoginFormOpen();
                    }}
                  >
                    Login
                  </NavLink>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * Render an alert modal informing the user what steps to take to correct the expiring credit card.
 * @extends Component
 */
class AlertDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = { showAlertDropdown: false };
    this.toggleAlertDropdown = this.toggleAlertDropdown.bind(this);
  }

  /**
   * Hide and show the alert modal informing the user what steps to take to correct the expiring credit card.
   */
  toggleAlertDropdown() {
    this.setState({ showAlertDropdown: !this.state.showAlertDropdown });
  }

  render() {
    const isOpen = this.state.showAlertDropdown;
    const { userDetails } = this.props;

    if (userDetails.showAlert === false) {
      return null;
    }

    return (
      <div className={`nav__alert${isOpen ? " is-open" : " is-closed"}`}>
        <FaExclamation size={10} onClick={this.toggleAlertDropdown} />
        <div className="fancy-dropdown__menu tooltip-modal cc-expiry">
          <h2 className="h2--dark mt--16">
            Your credit card{" "}
            {userDetails.isExpired === true
              ? "has expired"
              : "is expiring soon"}
            .
          </h2>
          <p>This means we will no longer be able to collect your donation.</p>
          <p>
            Please head to{" "}
            <NavLink
              className={({ isActive }) =>
                `cc-expiry__item ${isActive ? "active" : ""}`
              }
              to="/settings"
              onClick={this.toggleAlertDropdown}
            >
              Personal Details
            </NavLink>{" "}
            to update this today.
          </p>
        </div>
        <div
          className={`modal ${isOpen ? "modal--open" : "modal--closed"}`}
          onClick={this.toggleAlertDropdown}
        />
      </div>
    );
  }
}

const ConnectedAlertDropdown = connect(null, {
  ...actionsModals,
  ...actionsHelp,
})(AlertDropdown);

/**
 * Render a navigation modal giving links to other pages in the app.
 * @extends Component
 */
class UserDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = { showUserDropdown: false };
    this.toggleUserDropdown = this.toggleUserDropdown.bind(this);
    this.toggleUserDropdownLink = this.toggleUserDropdownLink.bind(this);
  }

  /**
   * Hide and show the navigation modal informing the user what pages they can direct to.
   */
  toggleUserDropdown() {
    this.setState({ showUserDropdown: !this.state.showUserDropdown });
  }

  toggleUserDropdownLink(event) {
    this.setState({ showUserDropdown: false });
  }

  render() {
    const isOpen = this.state.showUserDropdown;
    const { setModalHelpOpen, showAdmin, userDetails } = this.props;

    const handleLogOut = () =>
      Auth.doLogout().then(() => window.location.assign("/"));

    const handleStopImpersonating = () => {
      window.location.assign(`${getBaseUrl()}impersonate/stop?`);
    };

    return (
      <div
        className={`fancy-dropdown ${isOpen ? "is-open" : "is-closed"}`}
        onClick={this.toggleUserDropdown}
      >
        <h5>
          <MdMenu />
        </h5>
        <div className="fancy-dropdown__menu">
          <ol className="fancy-dropdown__list">
            {this.props.isAuthed && (
              <React.Fragment>
                <ol className="fancy-dropdown__top">
                  {this.props.reports && (
                    <li
                      className={`fancy-dropdown__item${
                        !this.props.isAuthed ? " hide" : ""
                      }`}
                    >
                      <NavLink
                        className={({ isActive }) =>
                          `fancy-dropdown__link ${isActive ? "active" : ""}`
                        }
                        to="/reports"
                        onClick={this.toggleUserDropdownLink}
                      >
                        Staff Reports
                      </NavLink>
                    </li>
                  )}
                  <li
                    className={`fancy-dropdown__item${
                      !this.props.isAuthed ? " hide" : ""
                    }`}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `fancy-dropdown__link ${isActive ? "active" : ""}`
                      }
                      to="/programs"
                      onClick={this.toggleUserDropdownLink}
                    >
                      Current Support
                    </NavLink>
                  </li>
                  <li
                    className={`fancy-dropdown__item${
                      !this.props.isAuthed ? " hide" : ""
                    }`}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `fancy-dropdown__link ${isActive ? "active" : ""}`
                      }
                      to="/payment"
                      onClick={this.toggleUserDropdownLink}
                    >
                      New Support
                    </NavLink>
                  </li>
                  <li
                    className={`fancy-dropdown__item${
                      !this.props.isAuthed ? " hide" : ""
                    }`}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `fancy-dropdown__link ${isActive ? "active" : ""}`
                      }
                      to="/settings"
                      onClick={this.toggleUserDropdownLink}
                    >
                      {userDetails?.organisation_name
                        ? "Organisation"
                        : "Personal"}{" "}
                      Details
                    </NavLink>
                  </li>
                  <li
                    className={`fancy-dropdown__item${
                      !this.props.isAuthed ? " hide" : ""
                    }`}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `fancy-dropdown__link ${isActive ? "active" : ""}`
                      }
                      to="/history"
                      onClick={this.toggleUserDropdownLink}
                    >
                      Support History
                    </NavLink>
                  </li>
                </ol>
                <li className="fancy-dropdown__item fancy-dropdown__item--divider">
                  <hr />
                </li>
              </React.Fragment>
            )}

            <li className="fancy-dropdown__item">
              <NavLink
                className={({ isActive }) =>
                  `fancy-dropdown__link secondary ${isActive ? "active" : ""}`
                }
                data-remodal-target="help-modal"
                to="/faq"
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleUserDropdownLink();
                  setModalHelpOpen();
                }}
              >
                Help
              </NavLink>
            </li>
            {this.props.isAuthed ? (
              <React.Fragment>
                {showAdmin && (
                  <li className={`fancy-dropdown__item`}>
                    <a className="fancy-dropdown__link secondary" href="/admin">
                      Admin
                    </a>
                  </li>
                )}
                {this.props.userDetails.isImpersonating && (
                  <li className="fancy-dropdown__item">
                    <a
                      className="fancy-dropdown__link secondary"
                      onClick={handleStopImpersonating}
                    >
                      Stop impersonating
                    </a>
                  </li>
                )}
                <li className={`fancy-dropdown__item`}>
                  <button
                    type="button"
                    className="fancy-dropdown__link secondary"
                    onClick={handleLogOut}
                  >
                    Logout
                  </button>
                </li>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <li className={`fancy-dropdown__item`}>
                  <a
                    href={`${process.env.REACT_APP_API_URL}/oauth/azure`}
                    className="fancy-dropdown__link"
                  >
                    Staff
                  </a>
                </li>
                <li className={`fancy-dropdown__item`}>
                  <a
                    className="fancy-dropdown__link secondary js__login"
                    href="programs"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.setModalLoginFormOpen();
                    }}
                  >
                    Login
                  </a>
                </li>
              </React.Fragment>
            )}
          </ol>
        </div>
      </div>
    );
  }
}

const mapStateToConnectedProps = (state) => {
  return {
    isAuthed: select.getIsLoggedIn(state),
    authedUserId: select.getSessionUserId(state),
    reports: state.session.userdata.reports,
    showAdmin: select.getSessionHasRoles(state, ["dev", "editor"]),
  };
};

const ConnectedUserDropdown = connect(mapStateToConnectedProps, {
  ...actionsModals,
  ...actionsSettings,
})(UserDropdown);

const mapStateToProps = (state) => {
  return {
    settings: select.getSettings(state),
    personal: select.getSettingsPersonal(state),
    creditCardExpired: select.getCardExpired(state),
    creditCardExpiring: select.getCardExpiring(state),
    isAuthed: select.getIsLoggedIn(state),
    authedUserId: select.getSessionUserId(state),
    reports: state.session.userdata.reports,
    isImpersonating: state.session.userdata.is_impersonating,
    showAdmin: select.getSessionHasRoles(state, ["dev", "editor"]),
  };
};

export default connect(mapStateToProps, {
  ...actionsModals,
  ...actionsSettings,
})(Navigation);
